module.exports = __webpack_public_path__ + "img/icon-warning-guide.4949450c.svg";